import axios from "axios";
import { logout } from "../lib/auth";
import { paymentTableColumn } from "../config/payment";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 明細詳細取得
export async function getServiceVersion() {
  try {
    const path = "serviceVersion";
    const response = await axios.get(CONST.apiUrl2 + path);
    return response.data.service_version as string;
  } catch (error) {
    return "error";
  }
}
